import {
  Anchor,
  Container,
  Divider,
  Flex,
  Image,
  Space,
  Stack,
  Text,
} from "@mantine/core";
import React from "react";

function Footer() {
  return (
    <Container
      fluid
      px={"xl"}
      py={"xl"}
      style={{
        width: "100%",
        backgroundColor: "#FFF",
      }}
      id="main-footer"
    >
      <Flex gap={64} justify={"space-between"}>
        <Flex align={"start"}>
          <Image
            src={"/images/logo-two.png"}
            style={{
              width: "8vw",
            }}
          />
        </Flex>

        <Flex direction={"column"}>
          <Text
            fw={700}
            style={{
              fontSize: "1.5vw",
              cursor: "pointer",
            }}
            c={"#2B71B9"}
            onClick={() => {
              document.getElementById("about-us")?.scrollIntoView();
            }}
          >
            About Us
          </Text>
          <Space h={"md"} />
          <Stack gap={10}>
            <Text
              c={"#2B71B9"}
              size="lg"
              style={{ cursor: "pointer" }}
              onClick={() => {
                document.getElementById("company-statement")?.scrollIntoView();
              }}
            >
              Mission
            </Text>
            <Divider color="#F21A27" size={"sm"} />
            <Text
              c={"#2B71B9"}
              size="lg"
              style={{ cursor: "pointer" }}
              onClick={() => {
                document.getElementById("company-statement")?.scrollIntoView();
              }}
            >
              Vision
            </Text>
            <Divider color="#F21A27" size={"sm"} />
            <Text
              c={"#2B71B9"}
              size="lg"
              style={{ cursor: "pointer" }}
              onClick={() => {
                document.getElementById("company-statement")?.scrollIntoView();
              }}
            >
              Core values
            </Text>
          </Stack>
        </Flex>

        <Flex direction={"column"}>
          <Text
            fw={700}
            style={{
              fontSize: "1.5vw",
            }}
            c={"#2B71B9"}
          >
            Location
          </Text>
          <Space h={"md"} />
          <Text c={"#2B71B9"} size="sm" fw={700}>
            Address
          </Text>
          <Text c={"#2B71B9"} size="sm">
            P.O Box 818 - 00520, Ruai , Nairobi
          </Text>
        </Flex>

        <Flex direction={"column"}>
          <Text
            fw={700}
            style={{
              fontSize: "1.5vw",
            }}
            c={"#2B71B9"}
          >
            Social Media
          </Text>
          <Space h={"md"} />
          <Flex align={"center"} gap={16}>
            <Anchor
              href="https://www.facebook.com/gibroenterprise"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Image src={"/images/facebook-icon-red.png"} h={22} w={22} />
            </Anchor>

            {/* <Anchor
              href="https://www.linkedin.com/company/gibroenterprise"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Image src={"/images/linkedin-icon-red.png"} h={22} w={22} />
            </Anchor> */}

            {/* <Anchor
              href="https://twitter.com/gibroenterprise"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Image src={"/images/twitter-icon-red.png"} h={22} w={22} />
            </Anchor> */}

            {/* <Anchor
              href="https://www.youtube.com/@gibroenterprise"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Image src={"/images/youtube-icon-red.png"} h={22} w={22} />
            </Anchor> */}

            <Anchor
              href="https://wa.me/254745246992"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Image src={"/images/whatsapp-icon-red.png"} h={22} w={22} />
            </Anchor>
          </Flex>

        </Flex>
      </Flex>
    </Container>
  );
}

export default Footer;
